import { render, staticRenderFns } from "./GCash.bak.vue?vue&type=template&id=10072be3"
import script from "./GCash.bak.vue?vue&type=script&lang=js"
export * from "./GCash.bak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports